(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbt-click-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bbt-navigation')) {
    customElements.define('bbt-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controllers = [...this.querySelectorAll('details')];
        this.onToggle = (event) => {
          if (!event.target.open) return;
          this.closeMenus(event.target);
          const panel = event.target.querySelector('.bbt-clicknav__panel');
          panel.style.left = '0px';
          const bounds = panel.getBoundingClientRect();
          panel.style.left = `${Math.min(0, window.innerWidth - 24 - bounds.right)}px`;
        };
        this.onResize = () => this.closeMenus();
        this.onOutside = (event) => { if (!event.composedPath().includes(this)) this.closeMenus(); };
        this.onFocusOut = (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeMenus(); };
        this.onEscape = (event) => {
          if (event.key !== 'Escape') return;
          const opened = this.controllers.find((item) => item.open);
          if (!opened) return;
          event.preventDefault(); this.closeMenus(); opened.querySelector('summary').focus();
        };
        this.controllers.forEach((item) => item.addEventListener('toggle', this.onToggle));
        document.addEventListener('pointerdown', this.onOutside);
        window.addEventListener('resize', this.onResize);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('keydown', this.onEscape);
      }
      closeMenus(except) { this.controllers.forEach((item) => { if (item !== except) item.open = false; }); }
      disconnectedCallback() {
        this.controllers?.forEach((item) => item.removeEventListener('toggle', this.onToggle));
        document.removeEventListener('pointerdown', this.onOutside);
        window.removeEventListener('resize', this.onResize);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('keydown', this.onEscape);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bbt-contact-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const widget = document.getElementById('bbt-contact-widget');
    if (!widget || widget.dataset.ready) return;
    widget.dataset.ready = 'true';
    const stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    if (stickyBar) {
      const updateOffset = () => {
        const height = stickyBar.dataset.stuck === 'true' ? stickyBar.getBoundingClientRect().height : 0;
        widget.style.setProperty('--bbt-contact-offset', height + 'px');
      };
      new ResizeObserver(updateOffset).observe(stickyBar);
      new MutationObserver(updateOffset).observe(stickyBar, { attributes: true, attributeFilter: ['data-stuck'] });
      updateOffset();
    }
    const toggle = widget.querySelector('summary');
    const close = () => { widget.open = false; toggle.focus(); };
    widget.querySelector('.bbt-contact-widget__close').addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && widget.open) { event.preventDefault(); close(); }
    });
    document.addEventListener('click', (event) => {
      if (widget.open && !widget.contains(event.target)) widget.open = false;
    });
    widget.addEventListener('focusout', () => {
      requestAnimationFrame(() => { if (!widget.contains(document.activeElement)) widget.open = false; });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
